import { useState, useEffect } from 'react';
import { calculatePercentageChange, determineCase } from '../utilities/adviceUtils';
import LoadingComponent from '../components/LoadingComponent';

const useAdviceGenerator = (
  balanceData, 
  budgetData, 
  omsætningIaltAmount, 
  omsætningBudgetAmount, 
  produktionsomkostningerAmount, 
  administrationsomkostningerAmount, 
  periodensResultatAmount, 
  produktionsomkostningerBudgetAmount, 
  administrationsomkostningerBudgetAmount, 
  periodensResultatBudgetAmount, 
  advices
  ) => {
    
    const [adviceList, setAdviceList] = useState([]);
    
    
    useEffect(() => {
        if(
            balanceData.length > 0 &&
            budgetData.length > 0 &&
            omsætningIaltAmount !== undefined &&
            produktionsomkostningerAmount !== undefined &&
            administrationsomkostningerAmount !== undefined &&
            periodensResultatAmount !== undefined &&
            produktionsomkostningerBudgetAmount !== undefined &&
            administrationsomkostningerBudgetAmount !== undefined &&
            periodensResultatBudgetAmount !== undefined
          ) {
            const toFixedSafe = (num, digits = 2) => {
              return (typeof num === 'number' && !isNaN(num)) ? num.toFixed(digits) : '0.00';
            };
            
            
            let adviceArr = [];
            const isDataLoaded = balanceData.length > 0 && budgetData.length > 0; [omsætningIaltAmount, omsætningBudgetAmount, produktionsomkostningerAmount, administrationsomkostningerAmount, periodensResultatAmount, produktionsomkostningerBudgetAmount, administrationsomkostningerBudgetAmount, periodensResultatBudgetAmount].every((item) => item !== undefined);

            if(isDataLoaded)
            {
            const omsætningChange = calculatePercentageChange(omsætningIaltAmount, omsætningBudgetAmount);
            const finalOmsætningChange = toFixedSafe(omsætningChange, 2);
            const produktionsomkostningerChange = calculatePercentageChange(produktionsomkostningerAmount, produktionsomkostningerBudgetAmount);
            const finalProduktionsomkostningerChange = toFixedSafe(produktionsomkostningerChange, 2);
            const administrationsomkostningerChange = calculatePercentageChange(administrationsomkostningerAmount, administrationsomkostningerBudgetAmount);
            const finalAdministrationsomkostningerChange = toFixedSafe(administrationsomkostningerChange, 2);
            const periodensResultatChange = calculatePercentageChange(periodensResultatAmount, periodensResultatBudgetAmount);
            const finalPeriodensResultatChange = toFixedSafe(periodensResultatChange, 2);
          
            
        
            const caseO = determineCase(finalOmsætningChange);
            const caseP = determineCase(finalProduktionsomkostningerChange);
            const caseA = determineCase(finalAdministrationsomkostningerChange);
            const caseD = determineCase(finalPeriodensResultatChange);
        
            const combinedCaseCode = `${caseO}${caseP}${caseA}${caseD}`;
            const combinedAdvice = advices[combinedCaseCode] || '';
            
            const finalAdvice = combinedAdvice
            .replace('%O%', finalOmsætningChange) 
            .replace('%P%', finalProduktionsomkostningerChange)
            .replace('%A%', finalAdministrationsomkostningerChange)
            .replace('%D%', finalPeriodensResultatChange);
            
            adviceArr.push(finalAdvice);
            
            setAdviceList(adviceArr);  
            } else {
                setAdviceList(<LoadingComponent />);
            }
          }
        
    }, [balanceData, budgetData, omsætningIaltAmount, omsætningBudgetAmount, produktionsomkostningerAmount, administrationsomkostningerAmount, periodensResultatAmount, produktionsomkostningerBudgetAmount, administrationsomkostningerBudgetAmount, periodensResultatBudgetAmount, advices]);

    return adviceList;
};

export default useAdviceGenerator;
